module.exports = __webpack_public_path__ + "joy-static/media/horizontal-ribbon1.fb7b2063.png";